// ./src/pages/private/EventSchedulePage/dateCancelStage.ts
//
// ROADMAP #199 — when the Schedule page offers "Cancel this date", and when its URL stage (`/schedule/:id/cancel`) may
// open. ⚠ ONE function for the button AND the stage (the URL-stage rule): a typed or restored URL must not reach past
// what the button would not offer. The server decides the cancel itself (`eventTimeSlotCancel`); this only decides
// what to show.
import type { Event, EventTimeSlot } from '@/utils/api';

/** The date is over: it ended (or, with no end, started) before `now`. */
export const dateIsOver = (slot: Pick<EventTimeSlot, 'startsAt' | 'endsAt'> | null | undefined, now: Date = new Date()): boolean => {
  const end = slot?.endsAt || slot?.startsAt;

  return !!end && new Date(end).getTime() <= now.getTime();
};

/** The cancel FORM: a saved date that is on, not over, of an event that is not itself cancelled. */
export const canCancelDate = (
  slot: EventTimeSlot | null | undefined,
  event: Pick<Event, 'eventStatus'> | null | undefined,
  now: Date = new Date(),
): boolean => !!slot?.id && !slot.canceledAt && event?.eventStatus !== 'canceled' && !dateIsOver(slot, now);

/** The stage: the form — or, on a date already cancelled, who was told and how its refunds are going. */
export const canOpenDateCancel = (
  slot: EventTimeSlot | null | undefined,
  event: Pick<Event, 'eventStatus'> | null | undefined,
  now: Date = new Date(),
): boolean => !!slot?.id && (!!slot.canceledAt || canCancelDate(slot, event, now));
